import _ from 'lodash'
import type { IModelsAPI } from '@wix/thunderbolt-symbols'
import type { BootstrapData } from '../../types'
import { BOOTSTRAP_DATA, MODELS_API, SERVICE_CONFIG_PROVIDER } from './moduleNames'
import { serviceConfigs } from '../../services/serviceLoaders'

const ServicesConfigs = (bootstrapData: BootstrapData, modelsApi: IModelsAPI): { [serviceDefinition: string]: any } => {
	return _.mapValues(serviceConfigs, (getConfig) => getConfig({ bootstrapData, modelsApi }))
}

export default {
	factory: ServicesConfigs,
	deps: [BOOTSTRAP_DATA, MODELS_API],
	name: SERVICE_CONFIG_PROVIDER,
}
